import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LeagueType {
  leagueId: number;
  name: string;
  description: string;
  showingName: string;
}

interface ScoringFormat {
  leagueId: number;
  name: string;
}

// Default league type object
const defaultLeagueType: LeagueType = {
  leagueId: 1,
  name: "Redraft League",
  description: "New team drafted each season, no keepers.",
  showingName: "Redraft",
};

// Default scoring format object
const defaultScoringFormat: ScoringFormat = {
  leagueId: 1,
  name: "PPR",
};

interface LeagueState {
  selectedLeague: any | null;
  setSelectedLeague: (league: any) => void;
  clearSelectedLeague: () => void;

  // League type specific methods
  LeagueType: LeagueType;
  setLeagueType: (leagueType: LeagueType) => void;
  clearLeagueType: () => void;

  // Scoring format specific methods
  ScoringFormat: ScoringFormat;
  setScoringFormat: (scoringFormat: ScoringFormat) => void;
  clearScoringFormat: () => void;
}

export const useLeagueStore = create<LeagueState>()(
  persist(
    (set) => ({
      selectedLeague: null,
      LeagueType: defaultLeagueType,
      ScoringFormat: defaultScoringFormat,

      setSelectedLeague: (league: any) => {
        set({ selectedLeague: league });
      },

      clearSelectedLeague: () => {
        set({ selectedLeague: null });
      },

      setLeagueType: (leagueType: LeagueType) => {
        set({ LeagueType: leagueType });
      },

      clearLeagueType: () => {
        set({ LeagueType: defaultLeagueType });
      },

      setScoringFormat: (scoringFormat: ScoringFormat) => {
        set({ ScoringFormat: scoringFormat });
      },

      clearScoringFormat: () => {
        set({ ScoringFormat: defaultScoringFormat });
      },
    }),
    {
      name: "league-storage",
      getStorage: () => localStorage,
    },
  ),
);
